import LocationEpisode from 'models/LocationEpisode';

export type SharedRecordTab = {
  key: string;
  label: string;
  subtitle: string;
  episodeId: string;
  locationEpisodeId: string;
  createdAt: string;
};

function tabFromRecord(record: LocationEpisode): SharedRecordTab {
  const name = record.owner.client.name || record.owner.clientName || record.owner.name || '';
  return {
    key: record.id,
    label: name ? `${name} Record` : 'Record',
    subtitle: record.owner.groupType?.displayName ?? '',
    episodeId: record.episodeId,
    locationEpisodeId: record.id,
    createdAt: record.createdAt,
  };
}

export function buildSharedRecordTabs(locationEpisode: LocationEpisode, episodeId: string): SharedRecordTab[] {
  const currentTab = { ...tabFromRecord(locationEpisode), key: 'current', episodeId };
  const linkedTabs = locationEpisode.sharedRecords.map(tabFromRecord);
  return [currentTab, ...linkedTabs].sort((a, b) => a.createdAt.localeCompare(b.createdAt));
}

export function buildSharedRecordTabsFromRecords(records: LocationEpisode[]): SharedRecordTab[] {
  return records.map(tabFromRecord).sort((a, b) => a.createdAt.localeCompare(b.createdAt));
}
